(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-perfil', {
            parent: 'entity',
            url: '/ss-perfil',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPerfils'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-perfil/s-s-perfils.html',
                    controller: 'SSPerfilController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-perfil-detail', {
            parent: 'ss-perfil',
            url: '/ss-perfil/{id}',
            data: {
            	authorities: ['ROLE_ADMIN'],
                pageTitle: 'SSPerfil'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-detail.html',
                    controller: 'SSPerfilDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSPerfil', function($stateParams, SSPerfil) {
                    return SSPerfil.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-perfil',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-perfil-detail.edit', {
            parent: 'ss-perfil-detail',
            url: '/detail/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-dialog.html',
                    controller: 'SSPerfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-perfil.new', {
            parent: 'ss-perfil',
            url: '/new',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-dialog.html',
                    controller: 'SSPerfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                solicitados: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-perfil', null, { reload: 'ss-perfil' });
                }, function() {
                    $state.go('ss-perfil');
                });
            }]
        })
        .state('ss-perfil.edit', {
            parent: 'ss-perfil',
            url: '/{id}/edit',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-dialog.html',
                    controller: 'SSPerfilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-perfil', null, { reload: 'ss-perfil' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-perfil.delete', {
            parent: 'ss-perfil',
            url: '/{id}/delete',
            data: {
            	authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-perfil/ss-perfil-delete-dialog.html',
                    controller: 'SSPerfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSPerfil', function(SSPerfil) {
                            return SSPerfil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-perfil', null, { reload: 'ss-perfil' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
